import { onDestroy } from "./_";

export default function (element) {
  const srcInitial = element.getAttribute("src-initial");
  const srcLoop = element.getAttribute("src-loop");

  if (!srcInitial) return;

  // Initial plays through once — strip the attribute-level loop
  element.removeAttribute("loop");
  element.src = srcInitial;
  element.load();
  element.play().catch(() => {});

  // No loop src → just loop the initial and bail
  if (!srcLoop) {
    element.setAttribute("loop", "");
    return;
  }

  // Clone inherits classes/variant/attributes for a pixel-perfect overlay
  const loopVideo = element.cloneNode(false);
  loopVideo.removeAttribute("data-module");
  loopVideo.removeAttribute("src-initial");
  loopVideo.removeAttribute("src-loop");
  loopVideo.removeAttribute("autoplay");
  loopVideo.setAttribute("loop", "");
  loopVideo.setAttribute("preload", "auto");
  loopVideo.src = srcLoop;

  Object.assign(loopVideo.style, {
    position: "absolute",
    inset: "0",
    width: "100%",
    height: "100%",
    opacity: "0",
    pointerEvents: "none",
  });

  const parent = element.parentElement;
  let parentWasStatic = false;
  if (parent && getComputedStyle(parent).position === "static") {
    parent.style.position = "relative";
    parentWasStatic = true;
  }
  element.insertAdjacentElement("afterend", loopVideo);
  loopVideo.load();

  const onEnded = () => {
    loopVideo.play().catch(() => {});
    loopVideo.style.opacity = "1";
    element.style.opacity = "0";
    element.pause();
  };

  element.addEventListener("ended", onEnded);

  onDestroy(() => {
    element.removeEventListener("ended", onEnded);
    loopVideo.pause();
    loopVideo.remove();
    element.style.opacity = "";
    if (parentWasStatic && parent) parent.style.position = "";
  });
}
